import React from 'react';
import { Button, FormField, MaskedInput, useDeviceType } from '@cian/ui-kit';
import { PHONE_MASK } from 'shared/utils/maskPhone';
import cn from 'clsx';

import s from './styles.css';
import { dispatchWidgetEvent, EAnalyticsEventType, EAuthWidgetEventName } from '../../../utils/dispatchWidgetEvent';
import { ETestIds } from '../../../constants/testIds';

interface IPhoneWindowProps {
  phone: string;
  changePhone: (value: string) => void;
  handleSendPhone: React.MouseEventHandler<HTMLButtonElement>;
  maskedPhone: string | null;
  inputDescription: string;
}

export const PhoneWindow: React.FC<IPhoneWindowProps> = ({
  phone,
  changePhone,
  handleSendPhone,
  maskedPhone,
  inputDescription,
}) => {
  const deviceType = useDeviceType();
  const handleSendPhoneWithAnalytics = (event: React.MouseEvent<HTMLButtonElement>) => {
    handleSendPhone(event);
    dispatchWidgetEvent(event.target, EAuthWidgetEventName.Analytics, EAnalyticsEventType.onPhoneScreenConfirm);
  };

  return (
    <div className={cn(s['wrapper'], s[deviceType])} data-testid={ETestIds.PhoneModal}>
      <div className={s['input']}>
        <FormField label="Телефон">
          <MaskedInput
            autoFocus
            placeholder={PHONE_MASK}
            mask={PHONE_MASK}
            size="M"
            value={phone}
            onChange={changePhone}
            data-testid={ETestIds.PhoneInput}
          />
        </FormField>
        <p className={s.text}>{inputDescription}</p>
      </div>
      <div className={cn(s['button-wrapper'], s[deviceType])}>
        <Button
          onClick={e => handleSendPhoneWithAnalytics(e)}
          disabled={maskedPhone === null}
          data-testid={ETestIds.EnterButton}
          size="L"
          fullWidth
        >
          Войти
        </Button>
      </div>
    </div>
  );
};
